import api from './apiClient';

const outcomeApi = {
  // Get all outcomes
  getOutcomes: (params) => api.get('/performance/outcomes', { params }),
  
  // Get outcome by ID
  getOutcomeById: (id) => api.get(`/performance/outcomes/${id}`),
  
  // Create new outcome
  createOutcome: (data) => api.post('/performance/outcomes', data),
  
  // Update outcome
  updateOutcome: (id, data) => api.put(`/performance/outcomes/${id}`, data),
  
  // Delete outcome
  deleteOutcome: (id) => api.delete(`/performance/outcomes/${id}`),
  
  // Approve outcome
  approveOutcome: (id, data) => api.post(`/performance/outcomes/${id}/approve`, data),
  
  // Reject outcome
  rejectOutcome: (id, data) => api.post(`/performance/outcomes/${id}/reject`, data),
  
  // Implement outcome
  implementOutcome: (id, data) => api.post(`/performance/outcomes/${id}/implement`, data),
  
  // Get outcomes by cycle
  getOutcomesByCycle: (cycleId) => api.get(`/performance/outcomes/cycle/${cycleId}`),
  
  // Get outcomes by employee
  getOutcomesByEmployee: (employeeId) => api.get(`/performance/outcomes/employee/${employeeId}`),
  
  // Export outcomes
  exportOutcomes: (params) => api.get('/performance/outcomes/export', { params }),
  
  // Get outcome KPI data
  getOutcomeKPI: () => api.get('/performance/outcomes/kpi')
};

export { outcomeApi };
